import type { AcademyVideo } from '../videos.interface'

export function filterVideosByTopics(videos: AcademyVideo[], selectedTopicIds: string[]): AcademyVideo[] {
  if (selectedTopicIds.length === 0) {
    return videos
  }

  const selected = new Set(selectedTopicIds)
  return videos.filter((video) => video.topicIds.some((topicId) => selected.has(topicId)))
}
